import { defineStore } from 'pinia'

export const useMultiplePayStore = defineStore('multiplePay', {
  state: () => {
    return {
      drafts: [],
      validateInsurancePolicyGroup: true,
      validateTouristVisaDepositDrafts: false
    }
  },
  actions: {
    setDrafts(drafts) {
      this.drafts = drafts
    }
  }
})
